import ListExchangeRates from './views/List.vue'
import CreateEditExchangeRate from './views/CreateEdit.vue'
import GetExchangeRate from './views/Get.vue'

export const ExchangeRateRoutes = [
  {
    path: '/exchange-rates',
    name: 'ListExchangeRates',
    component: ListExchangeRates,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'exchange_rate:list'
    }
  },
  {
    path: '/exchange-rate',
    name: 'CreateExchangeRate',
    component: CreateEditExchangeRate,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'exchange_rate:create'
    }
  },
  {
    path: '/exchange-rate/:id',
    name: 'UpdateExchangeRate',
    component: CreateEditExchangeRate,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'exchange_rate:update'
    }
  },
  {
    path: '/exchange-rate/view/:id',
    name: 'GetExchangeRate',
    component: GetExchangeRate,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'exchange_rate:get'
    }
  }
]
